import { render } from "./AddTagModal.vue?vue&type=template&id=3ea5a63b&scoped=true"
import script from "./AddTagModal.vue?vue&type=script&lang=js"
export * from "./AddTagModal.vue?vue&type=script&lang=js"

import "./AddTagModal.vue?vue&type=style&index=0&id=3ea5a63b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea5a63b"],['__file',"src/components/modals/AddTagModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ea5a63b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ea5a63b', __exports__)) {
    api.reload('3ea5a63b', __exports__)
  }
  
  module.hot.accept("./AddTagModal.vue?vue&type=template&id=3ea5a63b&scoped=true", () => {
    api.rerender('3ea5a63b', render)
  })

}


export default __exports__